// Copyright (c) 2025 Ipivot Corporation.
// All rights reserved.
'use strict'
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, LinearScale } from 'chart.js';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FingerprintStatLayer } from '../data';

ChartJS.register(ArcElement, Tooltip, Legend, LinearScale);

// import { Chart as ChartJS, CategoryScale, BarElement, BarController, LinearScale } from 'chart.js';
// ChartJS.register(CategoryScale, BarElement, BarController, LinearScale);

function LayerStats({ data }) {
    if (!data) {
        return <div>Loading...</div>;
    }
    let udata = data.bylayer;
    const cdata = {
        labels: udata.map((item: FingerprintStatLayer) => item.layer),
        datasets: [{
            label: 'Fingerprints',
            data: udata.map((item: FingerprintStatLayer) => item.count),
            backgroundColor: [
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
              ],
              borderColor: [
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255, 99, 132, 1)',
              ],
              borderWidth: 1,
        }],
        borderWidth: 1,
    }
    let total = udata.reduce((acc, row) => acc + row.count, 0);
    return (
        <Container fluid>
            <Row>
                <Col className="col-8">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Layer</th>
                                <th>Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            {udata.map((x, index) => (
                                <tr key={index}>
                                    <td>{x.layer}</td>
                                    <td>{x.count}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total</td>
                                <td>{total}</td>
                            </tr>
                        </tfoot>
                    </Table>
                </Col>
                <Col className="col-4">
                    <Pie data={cdata} />
                </Col>
            </Row>
        </Container>
    );
}
export default LayerStats;